import { Component, OnInit, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { LoaderService } from '../_services/loader.service';
import { MessagingService } from '../_services/messaging.service';
import { MediaMatcher } from '@angular/cdk/layout';
import { UserService } from '../_services/user.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-pages',
  templateUrl: './pages.component.html',
  styleUrls: ['./pages.component.css']
})
export class PagesComponent implements OnInit, AfterViewInit {
  isLoading = true;
  isLoggedIn: boolean;
  mobileQuery: any;
  user: any;
  userId = localStorage.getItem('currentUserId');
  private subscription: Subscription = new Subscription();
  private _mobileQueryListener: () => void;
  constructor(
    private router: Router,
    private msgService: MessagingService,
    private route: ActivatedRoute,
    private userService: UserService,
    private loaderService: LoaderService,
    private media: MediaMatcher,
    private cd: ChangeDetectorRef) {
    try {
      this.mobileQuery = this.media.matchMedia('(max-width: 1024px)');
      this._mobileQueryListener = () => this.cd.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
    } catch (e) {
    }
    this.subscription.add(this.userService.getUser().subscribe(user => {
      this.user = user
    
    }));


    this.subscription.add(this.router.events.subscribe(event => {


      this.isLoggedIn = this.router.url === "/" || this.router.url === "/about-us"
        || this.router.url === "/bigadvice-tour" || this.router.url.indexOf("landing-brand") > -1
        || this.router.url.indexOf("landing-page") > -1 || this.router.url === "/contact-us" ||
        this.router.url === "/confidentiality" || this.router.url === "/landing";
    }));
    this.subscription.add(this.loaderService.isLoaded().subscribe(data => {
      this.isLoading = data;
    }));
    this.msgService.getPermission();
    this.msgService.receiveMessage();
  }
  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.subscription.add(this.router.events.filter(event => event instanceof NavigationEnd)
      .subscribe(() => {
        const contentContainer = document.querySelector('.mat-sidenav-content') || window;
        contentContainer.scrollTo(0, 0);
      }));

  }



  ngAfterViewInit() {


  }
}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/pages.component.ts